module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/tab_arrow-b01e64e3a4bde12192eac6d1e3de78a8.svg";